import { useDispatch, useSelector } from 'react-redux';

import { getPageNumber, getPageSize, getTableSort } from 'selectors/lists';
import {
  toggleMembers,
  setPageSize,
  setPageNumber,
  setSort,
} from 'actions/lists';

import { ConstrainedTable } from '../styled';
import useConfig from './useConfig';
import { views } from 'components/Lists/constants';

const MembersTable = ({
  members,
  totalMembers,
  loading,
  view = views.researchers,
}) => {
  const dispatch = useDispatch();
  const pageNumber = useSelector(getPageNumber);
  const pageSize = useSelector(getPageSize);
  const sort = useSelector(getTableSort);

  const idKey = view === views.researchers ? 'researcherId' : 'id';

  const handleToggleAll = () => {
    dispatch(
      toggleMembers({ ids: members.map(m => m[idKey]), allOnPage: true })
    );
  };

  const handleToggleMember = id => {
    dispatch(toggleMembers({ id }));
  };

  const config = useConfig(
    handleToggleAll,
    handleToggleMember,
    view,
    totalMembers
  );

  const handlePageSize = size => dispatch(setPageSize(size));

  const handlePageNumber = number => dispatch(setPageNumber(number));

  const handleSortChange = sortKey => {
    dispatch(setSort(sortKey));
  };

  return (
    <ConstrainedTable
      paginate
      sortable
      config={config}
      data={members}
      loading={loading}
      onChangePageSize={handlePageSize}
      onChangePageNumber={handlePageNumber}
      pageSize={pageSize}
      pageNumber={pageNumber}
      resultSize={totalMembers}
      onSortChange={handleSortChange}
      sort={sort.by}
      sortDir={sort.dir}
    />
  );
};

export default MembersTable;
